import React, { useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
  Container,
} from 'reactstrap';
import cx from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { removeLoginParams } from '../../app/login/duck/actions/login';
import DropdownMenu from '../DropdownMenu/index';
import Rectangle from '../../assets/rectangle.svg';
import logo from '../../assets/navigation/logo@3x.png';
import config from '../../config/index';
import useChargebee from '../../hooks/useChargebee';

import style from './Navigation.module.scss';

const NavigationBar = ({ children }) => {
  const { firstName, lastName, bundleName, isAdmin, isLoggedIn } = useSelector(state => state.loginReducer);
  const location = useLocation();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);

  const { clickCallback: cbClickCallback } = useChargebee();

  const toggle = () => {
    setIsOpen(!isOpen);
  }

  return (
    <div>
      {isLoggedIn
        && (
          <Navbar className={style.navbar} expand="md">
            <Container>
              <div className={style.navBrand}>
                <NavLink style={{ display: 'inline' }} tag={Link} id="brand-link" to="/clients">
                  <img src={logo} alt="logo" height="20" width="188" />
                </NavLink>
              </div>
              <NavbarToggler className={style.toggler} onClick={toggle}>
                &#9776;
              </NavbarToggler>
              <Collapse isOpen={isOpen} navbar className={style.collapse}>
                <Nav className={style.navItems} navbar>
                  {children &&
                    children.map(element => (
                      <NavItem
                        key={element.props?.id}
                        className={cx('', {
                          [style.navLinkSelected]:
                            element.props?.to === location.pathname ||
                            (location.pathname === '/' && element.props?.to === "/clients"),
                        })}
                      >
                        <div>{element}</div>
                      </NavItem>
                    )
                    )}
                </Nav>
                <Nav className="ml-auto" navbar>
                  <NavItem>
                    <DropdownMenu
                      contentStyle={{
                        right: '-7px',
                        top: '39px',
                      }}
                      clickElement={(
                        <div className={style.userDropdown}>
                          <span className={style.name}>
                            {`${firstName} ${lastName}`}
                            {' '}
                            <img alt="" className={style.dropIcon} src={Rectangle} />
                          </span>
                          <span className={style.bundleName}>{bundleName && bundleName.toUpperCase()}</span>
                        </div>
                      )}
                    >
                      <div className={style.userDropdowContent}>
                        <div className={style.gotoCustomer}>
                          <button
                            className={style.dropLink}
                            onClick={cbClickCallback}
                          >
                            Billing
                          </button>
                        </div>
                        <div className={style.gotoCustomer}>
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            className={style.dropLink}
                            href={config.helpCentre}
                          >
                            Help Centre
                          </a>
                        </div>
                        {isAdmin && (
                          <div className={style.gotoCustomer}>
                            <span>
                              <a
                                className={style.dropLink}
                                href={config.admin}
                              >
                                Admin v1
                              </a>
                            </span>
                          </div>
                        )}
                        <div className={style.hr} />
                        <div className={style.gotoCustomer}>
                          <a
                            href="/login"
                            onClick={() => dispatch(removeLoginParams())}
                            className={style.dropLink}
                          >
                            Logout
                          </a>
                        </div>
                      </div>
                    </DropdownMenu>
                  </NavItem>
                </Nav>
              </Collapse>
            </Container>
          </Navbar>
        )
      }
    </div>
  );
}

NavigationBar.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  bundleName: PropTypes.string,
  isAdmin: PropTypes.bool,
  removeLoginParams: PropTypes.func,
  isLoggedIn: PropTypes.bool,
};

export default NavigationBar;
